import { render, staticRenderFns } from "./mian-head.vue?vue&type=template&id=43d4a77b&scoped=true"
import script from "./mian-head.vue?vue&type=script&lang=js"
export * from "./mian-head.vue?vue&type=script&lang=js"
import style0 from "./mian-head.vue?vue&type=style&index=0&id=43d4a77b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d4a77b",
  null
  
)

export default component.exports